/**
 * @file Placeholders.tsx
 * @description Блоки «Фото» и «Фасовки» нового товара до первого сохранения
 * (phase08.5; phase19.31 — без капса и мелкого текста, SC43).
 *
 * Фото и фасовки привязываются к товару, которого ещё нет в базе, поэтому до
 * сохранения блок только объясняет, когда он станет доступен.
 */

import { Camera, ImageIcon, Package } from "lucide-react";

import { SectionCard } from "./SectionCard";

const DISABLED_TIP = "Станет доступно после первого сохранения товара";

export function GallerySectionPlaceholder() {
  return (
    <SectionCard icon={<ImageIcon />} title="Фото">
      <div className="grid grid-cols-2 gap-3">
        {[0, 1].map((i) => (
          <div
            key={i}
            className="flex aspect-square items-center justify-center rounded-md border-2 border-dashed border-outline-variant text-on-surface-variant opacity-60"
          >
            <Camera className="size-7" aria-hidden />
          </div>
        ))}
      </div>
      <p className="type-caption text-on-surface-variant">{DISABLED_TIP}</p>
    </SectionCard>
  );
}

export function InventorySectionPlaceholder() {
  return (
    <SectionCard icon={<Package />} title="Фасовки">
      <p className="type-body text-on-surface-variant">
        Фасовки (вес, цена, артикул) добавляются после сохранения: товар без фасовки продать нельзя.
      </p>
    </SectionCard>
  );
}
